import { AddressDTO } from "./addressDTO";

export class PropertyOrderDTO{
    public id? : number;
    public propertyId! : string;
    public header? : string;
    public address? : AddressDTO;
    public imageReference? : string;
    public views? : number;
    public auctionId? : number;
    public auctionType? : number;
    public auctionStatus? : string;
    public soldAt? : string;
    public sellingPrice? : number;

    constructor(){
    }
}